module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"more":"More","teaser":"Summer 2015 – What inspires you?"},"de":{"more":"Mehr","teaser":"Sommer 2015 – Was ist Ihre Inspiration?"}}')
  delete Component.options._Ctor
}
